import type { ReactNode } from 'react';

/**
 * `*phrase*` → italic, for authored headlines that set part of the line in
 * italic ("Öğrenmenin *her halini keşfet.*"). An unpaired asterisk stays
 * literal, so "5* hizmet" renders as typed.
 */
export function withEmphasis(text: string, emWeight: number): ReactNode {
  const parts = text.split('*');
  if (parts.length < 3) return text;
  return parts.map((segment, i) => {
    if (i % 2 === 0) return segment;
    if (i === parts.length - 1) return `*${segment}`;
    return (
      <em key={i} style={{ fontStyle: 'italic', fontWeight: emWeight }}>
        {segment}
      </em>
    );
  });
}
